import clsx from 'clsx';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

interface IProgressToastProps {
    title?: ReactNode;
    msg?: string;
    containerClassName?: string;
}

const ProgressToast = ({
    msg,
    title = <FormattedMessage id="common.processing" defaultMessage="Processing" />,
    containerClassName,
}: IProgressToastProps) => {
    return (
        <div className="flex gap-2 items-center">
            <div className="min-h-[66px] w-1 bg-primary-600" />
            <div>
                <p className="font-museo font-bold text-primary-600 tracking-tight text-xs leading-7 uppercase">
                    {title}
                </p>
                <div className={clsx('md:min-w-[375px] text-black leading-7 text-sm font-roboto', containerClassName)}>
                    {msg}
                </div>
            </div>
        </div>
    );
};

export { ProgressToast };
export type { IProgressToastProps };
